import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';

import {IMPORT_PANEL_QS} from '../../../components/ReportPanelGridSection';
import {getNodeFromValue} from '../../../components/Slate/SlashMenu';
import {getEmptyReportConfig} from '../../../util/report';
import {trackCreateReportStarted} from './../../../services/analytics';
import {useApolloClient} from './../../../state/hooks';
import {pushReport} from './../../../state/reports/hooks';

export function useCreateReportInProject(location: string) {
  const apolloClient = useApolloClient();
  const history = useHistory();

  const createReportInProject = useCallback(
    async (entityName: string, projectName: string) => {
      trackCreateReportStarted({
        entityName,
        location,
        projectName,
      });

      await pushReport({
        client: apolloClient,
        entityName,
        projectName,
        config: getEmptyReportConfig([getNodeFromValue(`panel-grid`)]),
        opts: {
          redirectQS: {[IMPORT_PANEL_QS]: null},
        },
        history,
      });
    },
    [apolloClient, location, history]
  );

  return createReportInProject;
}
